// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Fvb","arrowIcon":"e_Gvb","title":"e_Hvb","titleText":"e_Ivb"};